<template>
  <div class="soha-ticket-card">
    <div :class="`soha-ticket-card-priority ${ticketPriority}`">
      <span>
        {{ ticket.priority }}
      </span>
    </div>
    <div class="row align-items-center m-0">
      <div class="col-12">
        <span class="mr-2">
          {{ ticket.title }}
        </span>
        <span :class="`soha-ticket-card-status ${ticketStatus}`">
          {{ ticket.status }}
        </span>
      </div>
      <div class="col-sm-6 col-12 mt-5">
        <span> {{ $t(`${I18nPrefix}DEPARTMENT`) }}: </span>
        <span>
          {{ ticket.department }}
        </span>
      </div>
      <div class="col-sm-6 col-12 mt-5">
        {{ $t(`${I18nPrefix}LAST_ANSWER_TIME`) }}:
        {{ toPersianDigits(lastAnswer) }}
      </div>
    </div>
  </div>
</template>

<script>
import UIMixin from "@/mixins/UIMixin";
import moment from "moment-jalaali";
import "@/assets/css/components/ticket/ticket-card.css";

const IMMEDIATE_PRIORITY = 1;
const IMPORTANT_PRIORITY = 2;
const NEW_STATUS = 1;
const WAITTNIG_STATUS = 2;
const SUPPORT_ANSWER_STATUS = 3;
const USER_ANSWER_STATUS = 4;
const OPEN_STATUS = 6;

export default {
  name: "TicketCard",

  mixins: [UIMixin],

  props: {
    ticket: {
      type: Object,
      require: true,
    },
  },

  data() {
    return {
      I18nPrefix: "COMPONENTS.TICKET.TICKET_CARD.",
    };
  },

  computed: {
    ticketPriority() {
      if (this.ticket.priorityId == IMMEDIATE_PRIORITY) return "immediate";
      if (this.ticket.priorityId == IMPORTANT_PRIORITY) return "important";
      return "normal";
    },

    ticketStatus() {
      if (
        this.ticket.statusId == NEW_STATUS ||
        this.ticket.statusId == OPEN_STATUS
      )
        return "new";
      if (this.ticket.statusId == WAITTNIG_STATUS) return "waitting";
      if (
        this.ticket.statusId == SUPPORT_ANSWER_STATUS ||
        this.ticket.statusId == USER_ANSWER_STATUS
      )
        return "answer";
      return "closeTicket";
    },

    lastAnswer() {
      return (
        this.$moment(this.ticket.last_message_at).format("dddd DD jMMMM YYYY") +
        " " +
        moment(this.ticket.last_message_at).format("HH:mm")
      );
    },
  },
};
</script>
